export default __webpack_public_path__ + "static/media/page-1-banner.c66cbcf9.jpeg";